module.exports = __webpack_public_path__ + "img/reset.485f5209.svg";